import {
  ButtonERP,
  DataTablePrimeReact,
  SearchInput,
} from "@finanedi.es/storybook"
import { IconName } from "@fortawesome/fontawesome-svg-core"
import { faPlus } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetTarjetasBancariasByFiltersDtoProps } from "api/DTOs/GetTarjetasBancariasByFiltersDto"
import { Tabs } from "common/components/Tabs"
import { DefaultTFuncReturn } from "i18next"
import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { Tarjetas } from "./pages/Tarjetas/Tarjetas"

const TarjetasBancarias = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const [addCardModal, setAddCardModal] = useState(false)

  const [keyword, setKeyword] = useState<string>()
  const [pagination, setPagination] = useState({
    itemsPerPage: 10,
    skipCount: 0,
  })
  const dtRef = useRef<DataTablePrimeReact<
    GetTarjetasBancariasByFiltersDtoProps[]
  > | null>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }

  const TabChild = ({
    icon,
    label,
  }: {
    icon?: IconName
    label?: DefaultTFuncReturn
  }) => (
    <div className='tw-flex tw-gap-2 tw-items-center tw-justify-center tw-w-40'>
      {icon && (
        <FontAwesomeIcon
          icon={["fal", icon]}
          className='tw-h-5'
        />
      )}
      {label && label}
    </div>
  )

  return (
    <div className='tw-flex tw-flex-col tw-order-2 tw-z-10 tw-relative tw-w-full tw-max-h-full tw-h-full tw-bg-gray tw-overflow-x-hidden tw-overflow-y-hidden custom-scrollbar'>
      <div className='tw-flex tw-items-center tw-justify-between tw-bg-white tw-px-6 !tw-h-20 tw-flex-shrink-0'>
        <Tabs
          defaultTabIndex={1}
          tabs={[
            {
              key: "tab1",
              children: (
                <TabChild
                  icon='landmark'
                  label={t("bancos.tab.accounts")}
                />
              ),
              onClickAction: () => {
                history.push(ROUTES.BANCOS)
              },
            },
            {
              key: "tab2",
              children: (
                <TabChild
                  icon='credit-card'
                  label={t("bancos.tab.cards")}
                />
              ),
            },
          ]}
        />
        <div className='tw-flex tw-items-center tw-justify-end tw-gap-1 lg:tw-gap-3'>
          <SearchInput
            placeholder={`${t("bancos.conciliacion.searchPlaceholder")}`}
            onChange={(ev: string) => {
              handleResetPagination()
              setKeyword(ev)
            }}
            inputValue={keyword}
            className='tw-mb-1 sm:tw-mb-0 tw-mr-2 lg:tw-mr-0 tw-h-10 tw-w-full sm:tw-w-72'
          />
          <ButtonERP
            onClick={() => setAddCardModal(true)}
            icon={<FontAwesomeIcon icon={faPlus} />}
            customize={{
              type: "secondary",
              size: "md",
            }}
            label={`${t("bancos.add.card")}`}
          />
        </div>
      </div>

      <Tarjetas
        addCardModal={addCardModal}
        setAddCardModal={setAddCardModal}
        keywordState={[keyword, setKeyword]}
        dtRef={dtRef}
        pagination={pagination}
        setPagination={setPagination}
      />
    </div>
  )
}

export default TarjetasBancarias
